import { Plus, Trash2 } from "lucide-react";

const inputClass =
  "w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-brand/20 focus:border-brand outline-none";

export default function LeadCallsEditor({ llamadas, onUpdate, onAdd, onRemove }) {
  return (
    <div className="border-t pt-4">
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs font-medium text-gray-500">Seguimiento de llamadas</p>
        <button
          type="button"
          onClick={onAdd}
          className="text-xs text-brand hover:text-brand-dark flex items-center gap-1"
        >
          <Plus size={14} /> Añadir llamada
        </button>
      </div>

      <div className="space-y-3">
        {llamadas.map((llamada, idx) => (
          <div
            key={idx}
            className={`flex items-start gap-2 p-3 rounded-lg border ${
              llamada.realizada
                ? "bg-emerald-50 border-emerald-200"
                : "bg-amber-50 border-amber-200"
            }`}
          >
            <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-2">
              <div>
                <label className="block text-xs text-gray-500 mb-1">Fecha</label>
                <input
                  type="date"
                  value={llamada.fecha || ""}
                  onChange={(e) => onUpdate(idx, "fecha", e.target.value)}
                  className={`${inputClass} text-xs`}
                />
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1">Resultado</label>
                <input
                  type="text"
                  value={llamada.resultado || ""}
                  onChange={(e) => onUpdate(idx, "resultado", e.target.value)}
                  className={`${inputClass} text-xs`}
                  placeholder="Resultado de la llamada..."
                />
              </div>
              <div className="sm:col-span-2">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={!!llamada.realizada}
                    onChange={(e) => onUpdate(idx, "realizada", e.target.checked)}
                    className="w-4 h-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500"
                  />
                  <span className="text-xs font-medium text-gray-600">Marcar realizada</span>
                </label>
              </div>
            </div>

            {llamadas.length > 1 && (
              <button
                type="button"
                onClick={() => onRemove(idx)}
                className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors mt-5"
              >
                <Trash2 size={14} />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
